<template>
  <div class="container">
    <el-row>
      <el-col :span="3">
        <zg-catalog title="原始记录（直观）" :route-name="'site_'+this.site_type+'_list'"></zg-catalog>
      </el-col>
      <el-col :span="21">
        <Toolbar
            :inspectStatus=true
            :buttons="[
              {text:'保存', type: 'success', onClick: handleSubmit},
              {text:'提交审核', type: 'primary', onClick: handleSubmitSh}
            ]"
            :currentRoute="currentRoute"
            :projectId="project_id"
            :siteId="site_id"
            :site-type="site_type"/>
        <hr>
        <el-form :model="form">
          <table>
            <tr>
              <td colspan="3"><p style="text-align:center;font-size: 48px">建 筑 电 气 防 火 检 测 <br> 原
                始 记 录</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>项目名称：</p>
              </td>
              <td>
                <el-input v-model="form.project_name"></el-input>
              </td>
              <td></td>
            </tr>
            <tr v-if="site_type==='sx'||site_type==='other'">
              <td>
                <p>场所名称：</p>
              </td>
              <td>
                <el-input v-model="form.site_name"></el-input>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>检测日期：</p>
              </td>
              <td>
                <el-date-picker style="width: 100%"
                                v-model="form.jcsj"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                </el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>检测人员：</p>
              </td>
              <td>
                <el-select disabled
                           v-model="form.jc_users"
                           multiple
                           filterable
                           default-first-option
                           placeholder="请选择检测人员" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.label"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>报告编号：</p>
              </td>
              <td>
                <el-input v-model="form.report_code"></el-input>
              </td>
              <td></td>
            </tr>
          </table>
          <br><br>
          <table>
            <tr>
              <td><p style="font-size: 20px">主&nbsp;&nbsp;&nbsp;检：</p></td>
              <td>
                <el-select disabled
                           v-model="form.zj"
                           multiple
                           filterable
                           default-first-option
                           placeholder="请选择主检" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td><p style="font-size: 20px">日期：</p></td>
              <td>
                <el-date-picker style="width: 100%"
                                v-model="form.zjrq"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                </el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><p style="font-size: 20px">记录员：</p></td>
              <td>
                <el-select disabled
                           v-model="form.jly"
                           filterable
                           default-first-option
                           placeholder="请选择记录员" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td><p style="font-size: 20px">日期：</p></td>
              <td>
                <el-date-picker style="width: 100%"
                                v-model="form.jlyrq"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                </el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><p style="font-size: 20px">审&nbsp;&nbsp;&nbsp;核：</p></td>
              <td>
                <el-select disabled
                           v-model="form.sh"
                           filterable
                           default-first-option
                           placeholder="请选择审核人" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td><p style="font-size: 20px">日期：</p></td>
              <td>
                <el-date-picker style="width: 100%"
                                v-model="form.shrq"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                </el-date-picker>
              </td>
              <td></td>
            </tr>
            <tr>
              <td><p style="font-size: 20px">审&nbsp;&nbsp;&nbsp;批：</p></td>
              <td>
                <el-select disabled
                           v-model="form.sp"
                           filterable
                           default-first-option
                           placeholder="请选择审批人" style="width: 100%">
                  <el-option v-for="item in project_employee_options" :key="item.value"
                             :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>

import Vue from "vue";
import RouteSelector from "@/components/RouteSelector.vue";
import Toolbar from "@/components/Toolbar.vue";

export default {
  components: {Toolbar, RouteSelector},
  data() {
    return {
      currentRoute: 'record_zg_index',
      project_id: '',
      site_id: '',
      site_type: '',
      project_employee_options: [],
      inspect_status: false,
      form: {
        project_name: '',
        site_name: '',
        report_code: '',
        jcsj: '',
        jc_users: [],
        zj: [],
        jly: [],
        zjrq: '',
        jlyrq: '',
        sh: '',
        shrq: '',
        sp: '',
        sprq: '',
      }
    }
  },
  methods: {
    handleSelectRoute(value) {
      switch (value) {
        case '1':
          console.log(value)
          break
      }
    },
    async getData() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
        }
        let res = await this.$Api.post('get_record_zg_index', params)
        if (res) {
          this.form = res
          this.form.jc_users = res.jc_users.split(',')
          this.form.zj = res.zj.split(',')
          this.form.jly = res.jly.split(',')
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleSubmit() {
      if (this.form.hasOwnProperty("id")) {
        this.onEdit()
      } else {
        this.onAdd()
      }
    },
    async onEdit() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.jc_users = this.form.jc_users.toString()
        params.zj = this.form.zj.toString()
        params.jly = this.form.jly.toString()
        await this.$Api.post('edit_record_zg_index', params)
        await this.getData()
        this.$message.success('修改成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async onAdd() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.jc_users = this.form.jc_users.toString()
        params.zj = this.form.zj.toString()
        params.jly = this.form.jly.toString()
        await this.$Api.post('add_record_zg_index', params)
        await this.getData()
        this.$message.success('新增成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //提交审核
    handleSubmitSh() {
      this.$confirm('提交审核之后原始记录不可修改，确认提交审核？', '确认审核', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
          async () => {
            try {
              await this.$Api.post('check_record_zg', {
                project_id: this.project_id,
                site_id: this.site_id,
                site_type: this.site_type
              })
              this.$message.success('提交成功')
              location.reload()
            } catch (e) {
              this.$message.error(e.errormsg)
            }
          }
      )
    },
    //获取人员下拉
    async getEmployeeOptions() {
      try {
        let res = await this.$Api.post('get_project_employee_options', {project_id: this.project_id})
        if (res) {
          this.project_employee_options = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'zg'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            let res2 = await this.$Api.post('get_site_employees', {
              project_id: this.project_id,
              site_id: this.site_id,
            })
            if (res2) {
              let current_employee_name = Vue.$Config.userinfo.employee_name
              if (res2.jc_users.split(',').includes(current_employee_name) ||
                  res2.zj.split(',').includes(current_employee_name) ||
                  res2.jly.split(',').includes(current_employee_name)
              ) {
                this.inspect_status = true
              }
            }
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getData()
    this.getEmployeeOptions()
    this.setButtonStatus()
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table tr td:first-child {
  width: 20%;
}

table tr td:last-child {
  width: 10%;
}

table td {
  text-align: right;
  font-size: 22px;
}

table tr td p {
  font-size: 22px;
  margin: 0.5em 0;
}
</style>